import axios from 'axios';
import { getAuthToken } from './auth';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.clear();
            window.location.href = '/login';
            console.error('Session expired. Please login again.');
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;